import React from 'react';

const RoehamptonPage = () => {
    const sectionStyle = {
        marginBottom: '2rem',
        padding: '1rem',
        borderBottom: '1px solid #ccc',
        border: '1px solid #ccc',
        borderRadius: '4px',
        color: 'white',
        backgroundColor: '#09122c',
    };

    const headingStyle = {
        color: 'white',
        fontSize: '1.5rem',
        marginBottom: '0.5rem',
        textAlign: 'left',
    };

    const listStyle = {
        marginLeft: '1.5rem',
    };

    return (
        <div style={{fontFamily: 'Arial, sans-serif', padding: '2rem', maxWidth: '800px', margin: 'auto'}}>
            <h1 style={{textAlign: 'center', color: '#34495e'}}>University of Roehampton Overview</h1>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>About</h2>
                <ul style={listStyle}>
                    <li>Location: South West London, UK</li>
                    <li>Campus: Parkland campus with modern facilities</li>
                    <li>Ranking: Top 15% globally (THE Young University Rankings 2024)</li>
                    <li>Research: Joint-best modern UK university for research (REF 2021)</li>
                    <li>Student Satisfaction: Top 10 for postgraduate satisfaction (PTES 2023)</li>
                    <li>Support: Academic, career, wellbeing, and financial guidance</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Courses Offered</h2>
                <h3>Undergraduate Degrees</h3>
                <ul style={listStyle}>
                    <li>Subjects: Business, Psychology, Education, Nursing, Law, Dance, and more</li>
                    <li>Foundation Year options available</li>
                    <li>Placement opportunities with industry partners</li>
                </ul>
                <h3>Postgraduate Degrees</h3>
                <ul style={listStyle}>
                    <li>MA, MSc, MBA, PGCE, and PhD programs</li>
                    <li>Flexible start dates and part-time options</li>
                    <li>Scholarships and alumni discounts available</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Tuition Fees</h2>
                <br/>
                <table style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                    <tr>
                        <th style={{borderBottom: '1px solid #ccc', textAlign: 'left'}}>Fee Type</th>
                        <th style={{borderBottom: '1px solid #ccc', textAlign: 'left'}}>Amount (GBP)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Undergraduate (UK)</td>
                        <td>£9,250 per year</td>
                    </tr>
                    <tr>
                        <td>Postgraduate (UK)</td>
                        <td>£7,500 – £12,500 depending on course</td>
                    </tr>
                    <tr>
                        <td>International Students</td>
                        <td>£13,473 – £15,000 per year</td>
                    </tr>
                    </tbody>
                </table>
                <p>Student Finance available for UK students via Student Finance England.</p>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>International Students</h2>
                <ul style={listStyle}>
                    <li>Visa Support: Tier 4 guidance and CAS issuance</li>
                    <li>English Requirements: IELTS 6.0+, TOEFL, PTE accepted</li>
                    <li>Dedicated international office and welcome week</li>
                    <li>Accommodation guaranteed for first-year international students</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Admissions</h2>
                <ul style={listStyle}>
                    <li>UCAS applications for undergraduate programs</li>
                    <li>Direct applications for postgraduate and international students</li>
                    <li>Entry: A-levels, IB, BTEC, or equivalent qualifications</li>
                    <li>Interviews required for some courses (e.g., PGCE, Nursing)</li>
                </ul>
            </section>

            <section style={sectionStyle}>
                <h2 style={headingStyle}>Why Choose Roehampton?</h2>
                <ul style={listStyle}>
                    <li>London-based campus with green space</li>
                    <li>Strong career support and employability focus</li>
                    <li>Inclusive and diverse student community</li>
                    <li>Top-rated for research and teaching quality</li>
                </ul>
            </section>

            <a href="https://www.roehampton.ac.uk" target="_blank" rel="noopener noreferrer">
                <footer style={{
                    color: "white",
                    textAlign: 'center',
                    width: "fit-content",
                    marginTop: '2rem',
                    padding: "10px",
                    borderRadius:"63px",
                    backgroundColor: "#09122C",
                    fontSize: '0.9rem',
                }}>
                    Visit roehampton.ac.uk for more info.
                </footer>
            </a>
        </div>
    );
};

export default RoehamptonPage;
